var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectDropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#F94054"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5824_94930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00036 2.76929C5.80391 2.76929 5.62424 2.9134 5.6374 3.08257L5.81888 7.31194C5.81888 7.35349 5.838 7.39333 5.87203 7.42271C5.90606 7.45209 5.95222 7.46859 6.00036 7.46859C6.04849 7.46859 6.09465 7.45209 6.12868 7.42271C6.16271 7.39333 6.18183 7.35349 6.18183 7.31194L6.36331 3.08257C6.37647 2.9134 6.19681 2.76929 6.00036 2.76929Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01134 9.2317C6.17402 9.2317 6.30589 9.1002 6.30589 8.93799C6.30589 8.77578 6.17402 8.64429 6.01134 8.64429C5.84867 8.64429 5.7168 8.77578 5.7168 8.93799C5.7168 9.1002 5.84867 9.2317 6.01134 9.2317Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5824_94930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.18182,
    height: 7.63636,
    fill: "white",
    transform: "translate(4.91016 2.18188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDropped);
export default __webpack_public_path__ + "static/media/project_dropped.ce38b76b17b9a70a424bacb8d1043336.svg";
export { ForwardRef as ReactComponent };